import React from 'react';
import { Alert, AlertIcon, AlertDescription } from '@chakra-ui/react';
import { useTranslation } from "react-i18next";

const CASBypassWarning: React.FC = () => {
    const { t } = useTranslation('common');
  return (
    <Alert status="info" colorScheme="cyan">
      <AlertIcon />

      <AlertDescription data-selector="casBypass-warning-text">
        {t('common:noteTheStudentSCasHasBeenProcess')}
                    </AlertDescription>
    </Alert>
  );
};

export default CASBypassWarning;
